import { MORTGAGE_PROMO_TYPES } from '../../../constants/promos';
import { type IPromo } from '../../../types/promos';

export function getAuthorDescription(promo: IPromo): string | null {
  if (promo.promoType === 'cianMortgage') {
    return null;
  }

  const isMortgage = promo.promoType != null && MORTGAGE_PROMO_TYPES.includes(promo.promoType);
  const promoLabel = isMortgage ? 'ипотечном' : 'акционном';
  const agentLabel = promo.isFromBuilder ? 'застройщика' : 'представителя застройщика';

  return `Узнайте у ${agentLabel} подробности об ${promoLabel} предложении`;
}
